import { render } from "./FeedbackReason.vue?vue&type=template&id=fc5de1f4"
import script from "./FeedbackReason.vue?vue&type=script&lang=js"
export * from "./FeedbackReason.vue?vue&type=script&lang=js"

import "./FeedbackReason.vue?vue&type=style&index=0&id=fc5de1f4&lang=css"

import exportComponent from "/codebuild/output/src3643421092/src/customer-feedback/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__